var render = function render(){var _vm=this,_c=_vm._self._c;return _c('state-container',{attrs:{"status":"closed","actions":_vm.actions}},[_c('mr-widget-author-time',{attrs:{"action-text":_vm.s__('mrWidget|Closed by'),"author":_vm.mr.metrics.closedBy,"date-title":_vm.mr.metrics.closedAt,"date-readable":_vm.mr.metrics.readableClosedAt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }